import { render, staticRenderFns } from "./ReverseTrapezoid.vue?vue&type=template&id=4c68c05e&scoped=true&"
import script from "./ReverseTrapezoid.vue?vue&type=script&lang=js&"
export * from "./ReverseTrapezoid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c68c05e",
  null
  
)

export default component.exports